<script setup lang="ts">
/**
 *
 *  Props and emits section
 *
 *
*/
const emit = defineEmits(['search'])
/**
 *
 *  Ref, computed and hooks section
 *
 *
*/
const search = defineModel<string>("search",{
    required:true
})
/**
 *
 *  Life cicle events
 *
 *
*/

/**
 *
 *  Functions section
 *
 *
*/
function searchF(){
  emit('search',search.value)
}
</script>

<template>
    <div
        class="tw-border tw-border-customGray-200 tw-rounded-full tw-overflow-hidden !tw-bg-transparent tw-mx-auto tw-w-full tw-h-10 tw-flex tw-gap-4 tw-pl-4 tw-pr-1">
        <div class="tw-flex tw-justify-between tw-w-full">
            <q-input :debounce="2000" rounded :outlined="false" borderless dense v-model:model-value="search"
                class="tw-flex-1 tw-w-full tw-my-auto tw-text-sm  md:tw-w-full tw-font-extralight tw-text-white lg:tw-text-customGray-400 tw-caret-primary !tw-bg-transparent"
                @keyup.enter="searchF">
                <template v-slot:append>
                    <q-icon dense name="close" size="16px" round flat @click="searchF"
                        class="tw-cursor-pointer tw-text-secondary hover:tw-text-accent tw-transition-all tw-duration-500 tw-ease-in-out"
                        v-if="search.length > 0"></q-icon>
                </template>

                <template v-slot:label>
                    <div>
                       <slot name="label" />
                    </div>
                </template>
            </q-input>
            <q-icon dense name="search" size="16px" round flat @click="searchF"
                class="tw-text-md tw-cursor-pointer tw-bg-primary hover:tw-bg-primary-800 tw-transition-all tw-duration-500 tw-ease-in-out tw-text-white tw-my-auto tw-px-4 tw-py-2 tw-rounded-full" />
        </div>
    </div>

</template>

<style scoped></style>